import { Flex, Image } from '@chakra-ui/react';
import styled from '@emotion/styled';
import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import Text from '@molecules/Text';
import BEIcon from '@molecules/BEIcon';
import Accommodation from '@data/models/Accommodation';

type Props = ModalProps & Accommodation;

const StyledModalContent = styled(Flex)`
  padding: 0 24px 24px;
`;

const ModalRatePlanDetails = (props: Props) => {
  const {
    images,
    title,
    packageId,
    packageTerms,
    packageDescription,
    isPackage,
  } = props;
  return (
    <ModalComponent
      {...props}
      title={packageId === '0' ? 'Standard Rate' : title}
      hideFooter={true}
      width={560}
      bodyPadding={false}
    >
      <StyledModalContent gap="24px" flexDirection="column">
        {isPackage && images.length > 0 && (
          <Image
            w="100%"
            h="250px"
            src={images[0].thumb}
            borderRadius="8px"
            objectFit="cover"
          />
        )}
        {isPackage && packageDescription && <Text html={packageDescription} />}
        {packageTerms && (
          <Flex flexDirection="column" gap="8px">
            <Text size="lg" weight="600">
              Policy
            </Text>
            <Flex gap="2px">
              <BEIcon name="calendar-check" />
              <Text size="md" mobilesize="sm" html={packageTerms} />
            </Flex>
          </Flex>
        )}
        {/* TODO: - new sections after api completion */}
      </StyledModalContent>
    </ModalComponent>
  );
};

export default ModalRatePlanDetails;
